/* eslint-disable import/no-anonymous-default-export */
import React, { useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  Select,
  Tooltip,
} from '@material-ui/core';
import { setSpecificSpecialEventData } from '../../../redux/actions/newOperationHoursActions';
import { formatTime } from '../../../utils/utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    root: {
      flexGrow: 1,
      borderBottom: '1px solid',
      borderBottomColor: '#bdbdbd',
      marginTop: 5,
    },
    demo: {
      backgroundColor: '#f5f5f5',
    },
  }),
);

export default function RowDigitalDriveThru({ disableAll, restaurantId = '' }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch: any = useDispatch();

  const restaurantServices = useSelector(
    (state: RootStateOrAny) => state.ServicesReducer.entities,
  );
  const driveThruService = restaurantServices.find(
    elem => elem.code === 'driveThru',
  );

  const {
    digitalDtTimeOpenMode,
    digitalDtTimeCloseMode,
    digitalDtIsClosedMode,
    drIsOpened24Hours,
    digitalDtIsOpened24HoursMode,
    dtIsOpened24Hours,
    digitalDtIsOpened24Hours,
    digitalDtIsClosed,
    drIsClosed,
    dtIsClosed,
    digitalDtTimeOpen,
    digitalDtTimeClose,
    availableTimes,
    specialDrDtTimes,
    is12HFormat,
  } = useSelector((state: RootStateOrAny) => state.NewOperationHoursReducer);

  const [selectOpenSelectedIndex, setSelectOpenSelectedIndex] = useState(0);

  const disabledSelects =
    disableAll || digitalDtIsClosed === 'Y' || digitalDtIsOpened24Hours === 'Y';

  const getValueSelectOpen = () => {
    if (digitalDtIsClosed === 'Y') {
      return '';
    } else if (digitalDtIsOpened24Hours === 'Y') {
      return availableTimes[1];
    } else {
      return digitalDtTimeOpen ? digitalDtTimeOpen : '';
    }
  };

  const getValueSelectClose = () => {
    if (digitalDtIsClosed === 'Y') {
      return '';
    } else if (digitalDtIsOpened24Hours === 'Y') {
      return '23:59';
    } else {
      return digitalDtTimeClose ? digitalDtTimeClose : '';
    }
  };

  const onChangeSelectOpen = event => {
    const select = event.target as HTMLSelectElement;
    if (digitalDtTimeOpen !== select.value) {
      dispatch(
        setSpecificSpecialEventData({
          digitalDtTimeOpen: select.value,
        }),
      );
    }
  };

  const onChangeSelectClose = event => {
    const select = event.target as HTMLSelectElement;
    if (digitalDtTimeClose !== select.value) {
      dispatch(
        setSpecificSpecialEventData({
          digitalDtTimeClose: select.value,
        }),
      );
    }
  };

  const onChangeCheckbox24hours = e => {
    const checked = e.target.checked;

    const newState: any = {};

    if (checked) {
      newState.digitalDtIsOpened24Hours = 'Y';
      newState.digitalDtIsClosed = 'N';
      newState.closeToAll = false;
      if (drIsOpened24Hours == 'Y' && hasOpenDriveThru()) {
        newState.open24Hours = true;
      }
    } else {
      newState.digitalDtIsOpened24Hours = 'N';
      newState.open24Hours = false;
    }

    dispatch(setSpecificSpecialEventData(newState));
  };

  const onChangeCheckboxIsClosed = e => {
    const checked = e.target.checked;

    const newState: any = {};

    if (checked) {
      newState.digitalDtIsClosed = 'Y';
      newState.digitalDtIsOpened24Hours = 'N';
      newState.open24Hours = false;
      if (drIsClosed == 'Y' && hasCloseDriveThru()) {
        newState.closeToAll = true;
      }
    } else {
      newState.digitalDtIsClosed = 'N';
      newState.closeToAll = false;
    }

    dispatch(setSpecificSpecialEventData(newState));
  };

  useEffect(() => {
    const index = availableTimes.findIndex(elem => elem === digitalDtTimeOpen);
    setSelectOpenSelectedIndex(index);
  }, [digitalDtTimeOpen]);

  return (
    <div className={classes.root}>
      <Grid container spacing={0}>
        <Grid item xs={4} md={4}>
          <div className={classes.demo}>
            <List>
              <ListItem>
                <ListItemText
                  primary={t('operationHours.mobileOrderDriveThru')}
                  primaryTypographyProps={{ display: 'inline' }}
                  secondary={!restaurantId ? <sup>++</sup> : ''}
                  secondaryTypographyProps={
                    !restaurantId
                      ? {
                          display: 'inline',
                          style: { fontSize: '12px', fontStyle: 'italic' },
                        }
                      : undefined
                  }
                />
              </ListItem>
            </List>
          </div>
        </Grid>
        <Grid item xs={1} md={1}>
          {digitalDtIsOpened24HoursMode.includes('read') ? (
            <Checkbox
              style={{ marginTop: 10 }}
              disabled={
                disableAll || !digitalDtIsOpened24HoursMode.includes('write')
              }
              checked={digitalDtIsOpened24Hours === 'Y'}
              onChange={onChangeCheckbox24hours}
            />
          ) : null}
        </Grid>
        <Grid item xs={1} md={1}>
          {digitalDtIsClosedMode.includes('read') ? (
            <Checkbox
              style={{ marginTop: 10 }}
              disabled={disableAll || !digitalDtIsClosedMode.includes('write')}
              checked={digitalDtIsClosed === 'Y'}
              onChange={onChangeCheckboxIsClosed}
            />
          ) : null}
        </Grid>
        <Grid item xs={3} md={3}>
          {digitalDtTimeOpenMode.includes('read') ? (
            <Tooltip title={''}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-time-native-simple">
                  {t('operationHours.start')}
                </InputLabel>
                <Select
                  style={
                    disabledSelects || !digitalDtTimeOpenMode.includes('write')
                      ? { pointerEvents: 'none', color: 'grey' }
                      : undefined
                  }
                  native
                  value={getValueSelectOpen()}
                  label={t('operationHours.start')}
                  inputProps={{
                    name: 'availableTimes',
                    id: 'outlined-time-native-simple',
                  }}
                  onChange={onChangeSelectOpen}
                  disabled={
                    disabledSelects || !digitalDtTimeOpenMode.includes('write')
                  }
                >
                  {availableTimes?.map((elem, index) => (
                    <option key={index} value={elem}>
                      {formatTime(elem, is12HFormat)}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Tooltip>
          ) : null}
        </Grid>
        <Grid item xs={3} md={3}>
          {digitalDtTimeCloseMode.includes('read') ? (
            <Tooltip title={''}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-time-native-simple">
                  {t('operationHours.close')}
                </InputLabel>
                <Select
                  style={
                    disabledSelects || !digitalDtTimeCloseMode.includes('write')
                      ? { pointerEvents: 'none', color: 'grey' }
                      : undefined
                  }
                  native
                  value={getValueSelectClose()}
                  inputProps={{
                    name: 'availableTimes',
                    id: 'outlined-time-native-simple',
                  }}
                  onChange={onChangeSelectClose}
                  disabled={
                    disabledSelects || !digitalDtTimeCloseMode.includes('write')
                  }
                >
                  {digitalDtIsOpened24Hours === 'Y' ? (
                    <option value={'23:59'}>
                      {formatTime('23:59', is12HFormat)}
                    </option>
                  ) : (
                    specialDrDtTimes
                      ?.filter(
                        (elem, index) =>
                          index > selectOpenSelectedIndex ||
                          (index === 0 && digitalDtIsClosed === 'Y'),
                      )
                      .map((elem, index) => (
                        <option key={index} value={elem}>
                          {formatTime(elem, is12HFormat)}
                        </option>
                      ))
                  )}
                </Select>
              </FormControl>
            </Tooltip>
          ) : null}
        </Grid>
      </Grid>
    </div>
  );

  function isDriveThruOpened24Hours() {
    return dtIsOpened24Hours === 'Y';
  }

  function isDriveThruClosed() {
    return dtIsClosed === 'Y';
  }

  function hasDriveThru() {
    return driveThruService?.value;
  }

  function hasOpenDriveThru() {
    return !hasDriveThru() || isDriveThruOpened24Hours();
  }

  function hasCloseDriveThru() {
    return !hasDriveThru() || isDriveThruClosed();
  }
}

RowDigitalDriveThru.displayName = 'RowDigitalDriveThru';
